import BotsErrorStatisticConfiguration from "./BotsErrorStatisticConfiguration.component";

export default BotsErrorStatisticConfiguration